import React from 'react';
import cn from 'classnames';
import { isMultiImageDeviation } from '../../DeviationViews/_helpers';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import s from './FullscreenDeviationPage.scss';
export const FullscreenPage = ({ deviation })=>{
    // todo: horrible to have to use this here... find a better way (:has?)
    // todo: or remove the overflow under the multi_file_deviation flag instead?
    const isMultiImage = isMultiImageDeviation(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], isMultiImage && s['multi-image'])
    }, /*#__PURE__*/ React.createElement(ArtStage, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(ActionBar, {
        deviation: deviation
    }));
};
export default FullscreenPage;

//# sourceMappingURL=FullscreenDeviationPage.js.map